import { useQuery } from 'react-query';
import { fetchBrowserAuthMe } from '../utils/api/browserAuthApi';
var useBrowserAuthMe = function () {
    var _a = useQuery('browserAuthMe', fetchBrowserAuthMe, {
        retry: false,
        staleTime: 300000,
    }), data = _a.data, error = _a.error, isLoading = _a.isLoading;
    return {
        error: error || undefined,
        isLoading: isLoading,
        user: data || undefined,
    };
};
export default useBrowserAuthMe;
